<!-- Header with logo -->
<header
  class="d-flex flex-wrap align-items-center justify-content-between py-3 mb-4 border-bottom"
>
  <div
    class="logo-container col-md-3 mb-2 mb-md-0 mx-2 d-flex align-items-center"
  >
    <a href="/" class="d-inline-flex align-items-center text-decoration-none">
      <img
        src="../assets/Nav-CO-Logo-CMYK-NoGradient-1.svg"
        alt="Logo"
        class="logo-img"
      />
    </a>
  </div>
  <div class="page-actions" *ngIf="isLoggedIn">
    <button class="btn btn-outline-danger" (click)="logout()">
      <i class="bi bi-box-arrow-right me-1"></i>Logout
    </button>
  </div>
</header>

<main class="main-content">
  <!-- Main content area -->
  <div class="center-div">
    <router-outlet></router-outlet>
  </div>
</main>

<!-- Footer -->
<footer class="footer py-2 mt-3">
  <div class="container text-center">
    <span class="text-muted">Patient Library</span>
  </div>
</footer>

<!-- Global loading indicator -->
<app-loading></app-loading>
